import costumes from './costumes.json';

import {removeTrademarkFromAssets} from '@repo/scratch-mod';

export default removeTrademarkFromAssets('costumes', costumes);
